import { selectXsrfToken } from 'modules/auth/selectors';
import watchProgress from 'model/watchProgress';
import * as auth from 'modules/auth';
import type { Dispatch, GetState } from '../../../../../model/State';
import { fetchLicenseById } from '../license';
import { fetchSingleOrder } from '../orders';

export default async (dispatch: Dispatch, getState: GetState) => {
  const xsrfToken = await watchProgress(selectXsrfToken);
  if (!xsrfToken) {
    auth.actions.goToLogin();
  }
  const { location } = getState();
  const { payload, query } = location;
  const licenseId = payload.licenseId || query?.licenseId || query?.license;
  const orderId = query?.orderId;

  if (licenseId) {
    dispatch(fetchLicenseById(licenseId));
  } else if (orderId) {
    dispatch(fetchSingleOrder(orderId));
  }
};
